export function normalizeWishlistCourseSlug(value: string): string {
  return value.trim().toLowerCase();
}

function withNormalizedSlug(slugs: ReadonlySet<string>, courseSlug: string): {
  normalizedSlug: string;
  nextSlugs: Set<string>;
} {
  const normalizedSlug = normalizeWishlistCourseSlug(courseSlug);
  const nextSlugs = new Set(slugs);

  return {
    normalizedSlug,
    nextSlugs,
  };
}

export function toggleWishlistMembership(
  slugs: ReadonlySet<string>,
  courseSlug: string
): { slugs: Set<string>; wished: boolean } {
  const { normalizedSlug, nextSlugs } = withNormalizedSlug(slugs, courseSlug);
  if (!normalizedSlug) {
    return { slugs: nextSlugs, wished: false };
  }

  if (nextSlugs.has(normalizedSlug)) {
    nextSlugs.delete(normalizedSlug);
    return { slugs: nextSlugs, wished: false };
  }

  nextSlugs.add(normalizedSlug);
  return { slugs: nextSlugs, wished: true };
}

export function setWishlistMembership(
  slugs: ReadonlySet<string>,
  courseSlug: string,
  wished: boolean
): Set<string> {
  const { normalizedSlug, nextSlugs } = withNormalizedSlug(slugs, courseSlug);
  if (!normalizedSlug) {
    return nextSlugs;
  }

  if (wished) {
    nextSlugs.add(normalizedSlug);
  } else {
    nextSlugs.delete(normalizedSlug);
  }

  return nextSlugs;
}

export function normalizeWishlistSlugs(values: readonly string[]): string[] {
  const deduped = new Set<string>();

  for (const value of values) {
    const normalized = normalizeWishlistCourseSlug(value);
    if (normalized) {
      deduped.add(normalized);
    }
  }

  return [...deduped];
}
